import { render, staticRenderFns } from "./goodsDialog.vue?vue&type=template&id=74aa44b1"
import script from "./goodsDialog.vue?vue&type=script&lang=js"
export * from "./goodsDialog.vue?vue&type=script&lang=js"
import style0 from "./goodsDialog.vue?vue&type=style&index=0&id=74aa44b1&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74aa44b1')) {
      api.createRecord('74aa44b1', component.options)
    } else {
      api.reload('74aa44b1', component.options)
    }
    module.hot.accept("./goodsDialog.vue?vue&type=template&id=74aa44b1", function () {
      api.rerender('74aa44b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/fullGift/components/goodsDialog.vue"
export default component.exports